import { Module } from "wrapper6";

var $ = jQuery;


export default class GiftWrapper extends Module {

  

  ready(app) {
    function triggerFragmentRefresh (data) {
      $.post(main_theme_objects.ajax_url, data, function(response) {
        if(response.hasOwnProperty('success') && response.success) {
          $( document.body ).trigger( 'wc_fragment_refresh' );
        }
      });
    }
  
    function getData (action, cartItemKey) {
      return {
        action: action,
        cart_item_key: cartItemKey
      };
    }

    $('input[type="checkbox"]').click(function() {
      if ($(this).is(":checked")) {
        var data = getData('woocommerce_add_gift_wrapping_fee', $(this).data('cart_id'))
        triggerFragmentRefresh(data)


      } else if ($(this).is(":not(:checked)")) {
        $("#isClicked").val("");
         var data = getData('woocommerce_remove_gift_wrapping_fee', $(this).data('cart_id'))
        triggerFragmentRefresh(data)
      }
    });
  }

}


// WEBPACK FOOTER //
// ./resources/js/modules/_giftwapper.js